// Video success stories from MCC's YouTube channel. Managed via the CMS.
// Add the student/parent name, class year and destination for each video once confirmed by MCC.
export type VideoStory = {
  youtubeId: string;
  title: string;
  speaker?: string;
  classYear?: string;
  destination?: string;
};

export const VIDEO_STORIES: VideoStory[] = [
  { youtubeId: "uTxi53xHTUs", title: "Success story 01" },
  { youtubeId: "bXqGZYQdiOM", title: "Success story 02" },
  { youtubeId: "TbuiSVsNJMM", title: "Success story 03" },
  { youtubeId: "4ymhw0gi8Gw", title: "Success story 04" },
];

export const CAMPUS_TOUR_VIDEO = { youtubeId: "EAfPR9nKIB8", title: "Maple Canadian College campus tour" };
